import React from 'react';
import { VscGame } from 'react-icons/vsc';
import timeIcon from './img/time-icon.svg';
import WeekChallengeSpinWheel from './week-challenge-spin-wheel';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import { ChallengeModalHat, ChallengeModalSection, ChallengeModalSectionNameHeader, ChallengeModalSectionNameSubtitle, ChallengeModalSectionNameTitle, ChallengeModalWarning } from '@/components/custom/challenge';
import { AvatarWrapper } from '@/components/ui/avatar';

export default function WeekChallengeStepName() {
  const { currentChallenge } = useWeeklyChallenge();

  return (
    <ChallengeModalSection variant="name">
      <ChallengeModalHat>{currentChallenge?.taxonomy?.name}</ChallengeModalHat>

      <ChallengeModalSectionNameHeader>
        <AvatarWrapper
          size="lg"
          src={currentChallenge?.image}
          text={currentChallenge?.user?.name}
          className="border-[8px] border-solid border-white"
        />

        <ChallengeModalSectionNameTitle>{currentChallenge?.title}</ChallengeModalSectionNameTitle>
        <ChallengeModalSectionNameSubtitle>
          <VscGame /> Desafio
        </ChallengeModalSectionNameSubtitle>
      </ChallengeModalSectionNameHeader>

      {currentChallenge && <WeekChallengeSpinWheel />}

      <ChallengeModalWarning>
        <img
          src={timeIcon}
          alt="ícone tempo"
        />
        Tente fazer no menor tempo!
      </ChallengeModalWarning>
    </ChallengeModalSection>
  );
}
